import vue from 'vue';

export default function buildProductLotStore(store){
    store.actions.getExchCatInfo = async (context, params) => await vue.prototype.$myHttp.post('/api/productLots/getExchCatInfo', params, true);
    store.actions.deleteItem = async (context, params) => await vue.prototype.$myHttp.post('/api/productLots/DeleteProductLot', params);
    return store;
}